<template>
  <div
    class="text"
    v-html="section.content"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TextSection',
  props: {
    id: {
      type: Number,
      default: -1
    }
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSectionById'
    ]),
    section () {
      return this.getSectionById(this.id)
    }
  }
}
</script>

<style scoped>
.text {
  word-wrap: break-word;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
